import { ContentDesktopButtonTooltipComponent } from "./content-desktop-button-tooltip.component";
import {
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Injector,
  Input,
  Renderer2,
  ApplicationRef,
  Inject,
  ViewContainerRef,
  ChangeDetectorRef
} from "@angular/core";
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[raContentDesktopButtonTooltip]',
  standalone: true,
})
export class ContentDesktopButtonTooltipDirective {
  @Input() tooltipText!: string;
  @Input() buttonActive?: boolean;
  private componentRef: ComponentRef<ContentDesktopButtonTooltipComponent> | null = null;

  constructor(
    private injector: Injector,
    private renderer: Renderer2,
    private hostElement: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private viewContainerRef: ViewContainerRef
  ) {}

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(): void {
    if (!this.componentRef && !!this.buttonActive) {
      this.createComponent();
    }
  }

  private createComponent() {
    const viewContainerRef = this.viewContainerRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent(ContentDesktopButtonTooltipComponent, { injector: this.injector });
    this.componentRef.instance.tooltipText = this.tooltipText;

    const componentRootNode = this.componentRef.location.nativeElement;
    // Обновляем привязки и размеры перед расчетом позиции
    this.componentRef.changeDetectorRef.detectChanges();

    // Вычисляем позицию для центрирования относительно родительского элемента
    const hostRect = this.hostElement.nativeElement.getBoundingClientRect();
    const tooltipWidth = componentRootNode.offsetWidth;
    const left = hostRect.left + (hostRect.width / 2) - (tooltipWidth / 2) + window.scrollX;

    // Устанавливаем стили позиционирования
    componentRootNode.style.position = 'absolute';
    componentRootNode.style.top = `${hostRect.bottom + window.scrollY + 18}px`;
    componentRootNode.style.left = `${left}px`;

    this.renderer.appendChild(this.document.body, componentRootNode);
  }

  @HostListener('mouseleave')
  @HostListener('click')
  onMouseLeave(): void {
    this.destroyComponent();
  }

  private destroyComponent() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
      this.viewContainerRef.clear();
    }
  }
}
